import loadable from '@loadable/component';

export const CmsTableOfContentsLoadable = loadable(
  () => import('./CmsTableOfContents'),
  { resolveComponent: (module) => module.CmsTableOfContents },
);
